import { render, staticRenderFns } from "./deviceMsg.vue?vue&type=template&id=42198716&"
import script from "./deviceMsg.vue?vue&type=script&lang=js&"
export * from "./deviceMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports